module.exports = __webpack_public_path__ + "img/user-17.c95383c5.svg";